import Layout from '@/views/order-log/Layout.vue';

export default {
    path: '/order-log',
    component: Layout,
    children: [
        { path: '', component: () => import('@/views/order-log/OrderLog.vue') },
        { path: 'settings', component: () => import('@/views/order-log/OrderSettings.vue') },
    ]
};
